import { useState } from "react";
import styled from "styled-components";
import angleDown from "assets/icons/angleDownIcon.svg";
import RadioInput from "components/global/RadioInput";
import Spacer from "components/global/Spacer";
import { useClickOutside } from "webrix/hooks";
import PlatformPhoto from "components/global/PlatformPhoto";
import { socialIcons, supportedPlatforms } from "constants/post";
import useManageChannels from "hooks/useManageChannels";
import { connect } from "react-redux";
import {
  ConnectInstagramToFacebook,
  InstagramAccountConvertInfo,
} from "views/socialMedia/ChannelInfoModals";
import InstagramConnectionModal from "./newAnalytics/InstagramConnectionModal";
import { fbTestEmail } from "utils/utils";

const Wrapper = styled.div`
  width: ${({ width }) => (width ? width : "100%")};
  height: ${({ height }) => (height ? height : "100%")};
  border: 1px solid
    ${({ isSelected }) => (isSelected ? "var(--secondary)" : "var(--grey_10)")};
  border-radius: 8px;
  position: relative;
  padding: 8px 12px;

  .dropdown-items {
    padding: 0 8px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  .angle_down {
    transition: transform 0.3s ease;

    &.rotate {
      transform: rotate(180deg);
    }
  }

  .dropdown-header {
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({ isSelected }) =>
      isSelected ? "var(--secondary)" : "var(--grey_1)"};
  }

  .dropdown-btn {
    width: 16px;
    min-width: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
  }
`;

const Dropdownlist = styled.div`
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.05), 0px 25px 35px rgba(0, 0, 0, 0.03);
  border-radius: 8px;
  padding: 8px;
  width: 240px;
  margin-top: 3px;
  z-index: 2;
  background: #fff;
  font-weight: 450;
  font-size: 14px;
  position: absolute;
  top: 100%;
  right: ${({ dropdownPosition }) => (dropdownPosition === "right" ? "" : "0")};
  overflow-y: scroll;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  .list-header {
    padding: 0 8px;
    font-size: 14px;
    font-weight: 450;

    .dropdown_header_btn {
      font-size: 14px;
      font-weight: 450;
      color: var(--secondary);
    }
  }

  .checkbox {
    width: 16px;
    height: 16px;

    &::after {
      width: 10px;
      height: 10px;
    }
  }

  .select_row {
    margin-top: 9px;
    padding: 8px;

    &:hover {
      cursor: pointer;
    }
  }

  .checkbox-container {
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;

    .social_detail {
      width: 100%;
      gap: 8px;
    }

    .title {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;

const SelectChannels = ({
  width,
  height,
  dropdownPosition,
  selectedPlatform,
  setSelectedPlatform,
  channels,
  brand,
  user,
}) => {
  const {
    handleConnectPlatform,
    connecting,
    removeSocial,
    setSelectedChannel,
  } = useManageChannels(brand?.id);

  const [isOpen, setIsOpen] = useState(false);
  const [showInstagramModal, setShowInstagramModal] = useState(false);

  const handleOnMouseDownCapture = useClickOutside(() => {
    setIsOpen(false);
  });

  const handleChannelSelection = (channel) => {
    if (
      channel?.platform === "instagram" &&
      channel?.page?.connect_with === "instagram" &&
      !fbTestEmail[0]?.includes(user.email)
    ) {
      setSelectedChannel(channel);
      setShowInstagramModal(true);
    } else {
      setSelectedPlatform(channel);
    }
    setIsOpen(false);
  };

  const handleConnectWithFacebook = () => {
    removeSocial();
    setShowInstagramModal(false);
    document.querySelector(".InstagramConvertInfo").classList.add("show");
  };

  return (
    <>
      {/* Instagram Personal to business account guide */}
      <InstagramAccountConvertInfo
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("instagram")}
      />

      {/* Authenticate Instagram with facebook guide */}
      <ConnectInstagramToFacebook
        disabled={connecting}
        handleConnection={() => handleConnectPlatform("instagram")}
      />

      <Wrapper
        onMouseDownCapture={handleOnMouseDownCapture}
        width={width}
        height={height}
      >
        <div className="dropdown-items" onClick={() => setIsOpen(!isOpen)}>
          <header className="dropdown-header">
            {selectedPlatform?.platform ? (
              <div className="flexRow alignCenter social_detail">
                <PlatformPhoto>
                  <img
                    src={socialIcons.circle[selectedPlatform?.platform]}
                    alt="text"
                    width="20px"
                    className="social_icon"
                  />
                </PlatformPhoto>
                <Spacer x={0.5} />
                <p className="title">{selectedPlatform?.page?.name}</p>
              </div>
            ) : (
              <>No socials selected</>
            )}
          </header>

          <button className="dropdown-btn">
            <img
              src={angleDown}
              alt="angle down"
              className={`angle_down ${isOpen ? "rotate" : ""}`}
            />
          </button>
        </div>

        {isOpen && (
          <Dropdownlist
            className="dropdown-list"
            dropdownPosition={dropdownPosition}
          >
            <header className="list-header flexRow alignCenter justifySpaceBetween">
              <p>Select channel</p>

              {/* {selectedPlatform && (
                <button
                  className="dropdown_header_btn"
                  onClick={() => setSelectedPlatform({})}
                >
                  Clear
                </button>
              )} */}
            </header>
            <Spacer y={0.8} />

            {channels.map((channel, idx) => {
              return (
                <div
                  className="flexRow alignCenter justifySpaceBetween select_row"
                  key={idx}
                >
                  <button
                    type="button"
                    className="checkbox-container"
                    onClick={() => handleChannelSelection(channel)}
                  >
                    <RadioInput
                      className="checkbox"
                      id={`_${idx}`}
                      name={`_${idx}`}
                      checked={selectedPlatform?.platform === channel.platform}
                      value={channel.platform}
                      label={channel?.name}
                    />
                    <div className="flexRow alignCenter social_detail">
                      <PlatformPhoto>
                        <img
                          src={socialIcons.circle[channel.platform]}
                          alt="text"
                          width="20px"
                          className="social_icon"
                        />
                      </PlatformPhoto>
                      <p className="title">{channel?.page?.name}</p>
                    </div>
                  </button>
                </div>
              );
            })}
          </Dropdownlist>
        )}
      </Wrapper>

      <InstagramConnectionModal
        showModal={showInstagramModal}
        onCancel={() => {
          setShowInstagramModal(false);
          setSelectedChannel(null);
        }}
        onConnectWithFacebook={handleConnectWithFacebook}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    brand: state.brand,
    user: state.user,
  };
};

export default connect(mapStateToProps)(SelectChannels);
